module.exports = __webpack_public_path__ + "static/img/laboratory3.1a836c1.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/laboratory3.jpg
// module id = no9W
// module chunks = 1